export const humanizedServiceLevel = serviceLevel => {
  if (serviceLevel === "creator") {
    return "Creator"
  } else if (serviceLevel === "creator_pro") {
    return "Pro"
  } else if (serviceLevel === "newsletter_paid") {
    return "Newsletter"
  } else {
    throw "Service level not recognized"
  }
}

export const onboardingSurveyRequired = (
  accountIsNewsletter,
  targetServiceLevel
) => {
  // accounts moving to creator and pro do not need to go to onboarding
  if (
    targetServiceLevel === "creator" ||
    targetServiceLevel === "creator_pro"
  ) {
    return false
  }

  // moving from a newsletter plan to a newsletter plan does not require onboarding
  if (
    accountIsNewsletter &&
    (targetServiceLevel === "newsletter_paid" ||
      targetServiceLevel === "newsletter_free")
  ) {
    return false
  }

  // all other scenarios require an onboarding flow
  return true
}

export function consiceInterval(interval) {
  if (interval === "month") {
    return "mo"
  } else if (interval === "year") {
    return "yr"
  } else {
    return null
  }
}

export const CTATextFor = (accountPlan, targetPlan) => {
  if (!accountPlan || !targetPlan) {
    return null
  }

  const CTATexts = {
    creator: {
      creator: "Stay on Creator",
      creator_pro: "Upgrade to Pro",
      newsletter_free: "Downgrade to Newsletter",
      newsletter_paid: "Switch to Newsletter"
    },
    creator_pro: {
      creator: "Downgrade to Creator",
      creator_pro: "Stay on Pro",
      newsletter_paid: "Downgrade to Newsletter"
    },
    newsletter_free: {
      creator: "Upgrade to Creator",
      creator_pro: "Upgrade to Pro",
      newsletter_free: "Stay on Newsletter",
      newsletter_paid: "Switch to Newsletter"
    },
    newsletter_paid: {
      creator: "Upgrade to Creator",
      creator_pro: "Upgrade to Pro",
      newsletter_free: "Switch to Newsletter",
      newsletter_paid: "Stay on Newsletter"
    }
  }

  return CTATexts[accountPlan][targetPlan]
}

// Analytics properties for whether a plan is shown with a discount, so upgrade
// funnels can be compared for discounted and full-price plans.
export const discountTrackingProperties = plan => {
  const isDiscounted = Boolean(plan?.promo_code?.valid)

  return {
    is_discounted: isDiscounted,
    promo_code: isDiscounted ? plan.promo_code.redemption_code : null
  }
}
